import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import { PusherProvider } from './lib/context/PusherContext';
import './index.css';
import '../src/otpStyle/indexotp.css';
import { PostHogProvider } from 'posthog-js/react';
import { PostHogConfig } from 'posthog-js';
import { setupGlobalErrorHandlers } from './lib/errors/errorTracking';

// Set up global error handlers for unhandled rejections and uncaught errors
setupGlobalErrorHandlers();

const options: Partial<PostHogConfig> = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
 
};
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={options}>
      <PusherProvider>
        <App />
      </PusherProvider>
    </PostHogProvider>
  </React.StrictMode>,
);
